// extracted by mini-css-extract-plugin
export default {"layout":"PatternGrid_layout__pmjiX","vertical":"PatternGrid_vertical__Bwf3J","horizontal":"PatternGrid_horizontal__AuGaC"};